export const roots = [
	'products',
	'market',
	'kancelyaria',
	'gotovye',
	'aksessuari',
]
